import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SfcModule } from "@sfc/angular";
import { HeaderComponent } from "./header/header.component";
import { ToasterComponent } from "./shared/toaster/toaster.component";

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, SfcModule, HeaderComponent, ToasterComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'arca-ui';
}
